import { render } from "./Test.vue?vue&type=template&id=cc6dc81a&scoped=true"
import script from "./Test.vue?vue&type=script&lang=ts"
export * from "./Test.vue?vue&type=script&lang=ts"

import "./Test.vue?vue&type=style&index=0&id=cc6dc81a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cc6dc81a"

export default script